<template>
  <transition name="route-fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { debounce } from './utils'

export default {
  computed: {
    ...mapFields({
      userDashSideOpen: 'ui.userDashSideOpen'
    })
  },
  methods: {
    onResize: function() {
      if (window.innerWidth < 992) {
        this.$store.commit('hideDashSide')
      }
    }
  },
  mounted: function() {
    this.onResize()
    window.addEventListener('resize', debounce(this.onResize, 250))
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="scss">
@import './scss/main';
</style>
